"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var SelectCustom_vue_1 = __importDefault(require("../Input/SelectCustom.vue"));
var DatepickerDate_vue_1 = __importDefault(require("../Input/DatepickerDate.vue"));
var TextMultiline_vue_1 = __importDefault(require("../Input/TextMultiline.vue"));
var Row_vue_1 = __importDefault(require("../Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("../Layout/Column.vue"));
exports.default = vue_1.default.extend({
    props: ['name'],
    components: { SelectCustom: SelectCustom_vue_1.default, DatepickerDate: DatepickerDate_vue_1.default, TextMultiline: TextMultiline_vue_1.default, HeRow: Row_vue_1.default, HeColumn: Column_vue_1.default },
    methods: {
        getGestionTransfoValue: function () {
            var self = this, id = this.$root.$data.data[this.$refs.select.name] || 0;
            if (id && id > 0) {
                $.ajax({
                    url: '/Affaires/GetGestionTransfo',
                    type: 'get',
                    data: {
                        id: id
                    },
                }).done(function (data) {
                    self.$refs.select.value = data;
                });
            }
            return "";
        }
    },
    mounted: function () {
        this.getGestionTransfoValue();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/PoseTransformateur.vue
// module id = 212
// module chunks = 0